import React from 'react'
import { useProjectContext } from '../../context/ProjectContext'

const UndoRedoButtons = () => {
  const { undo, redo, canUndo, canRedo } = useProjectContext()

  return (
    <div className="undo-redo-buttons">
      <button
        type="button"
        onClick={undo}
        disabled={!canUndo}
        title="Undo"
        className="undo-redo-btn undo-button"
      >
        <span className="undo-redo-icon">↶</span>
        <span className="undo-redo-label">Undo</span>
      </button>

      <button
        type="button"
        onClick={redo}
        disabled={!canRedo}
        title="Redo"
        className="undo-redo-btn redo-button"
      >
        <span className="undo-redo-icon">↷</span>
        <span className="undo-redo-label">Redo</span>
      </button>
    </div>
  )
}

export default UndoRedoButtons